import PrimaryButton from "../PrimaryButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { validateOTP, verifyOTP } from "../../apis/otp";
import { toast } from "react-toastify";

export default function SignupVerifyButton({
  userId,
  errorOTP,
  setErrorOTP,
  OTPValue,
  navigateTo
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSendOTP = async () => {
    if (!userId) navigate("/signup");

    if (!OTPValue) {
      setErrorOTP("invalid_otp");
      return;
    }

    if (OTPValue.length !== 6) {
      setErrorOTP("invalid_otp_length")
      return
    }

    const OTPVerifyResult = await verifyOTP(userId, OTPValue)

    if (OTPVerifyResult.status !== 200) {
      if (OTPVerifyResult.status === 401) {
        setErrorOTP("invalid_otp")
        return
      }

      setErrorOTP(OTPVerifyResult.statusText)
      return
    }

    toast(t("register_success"));

    setTimeout(() => {
      navigate(navigateTo);
    }, 1000);
  };
  return <PrimaryButton text={t("signup")} onClick={handleSendOTP} />;
}
